
import { useStore } from '@/composables/use-store'
import { Translation } from '@/types/i18n'
import { computed, defineComponent, PropType } from 'vue'

/**
   Text field component that edits the given
   translation key's value for all available languages.

   Shows a text field for each language side by side.
   Translation key is displayed below the text fields.

   Props:
   - translationKey: The i18n key to edit
   - label: Label shown above the text fields
 **/
export default defineComponent({
  name: 'MultiTranslatedTextField',
  props: {
    translationKey: {
      type: String as PropType<string>,
      required: true
    },
    label: {
      type: String as PropType<string>,
      required: true
    }
  },
  setup (props) {
    const store = useStore()

    const localesMap: Record<string, Translation> =
      store.getters['campaigns/currentLocales']

    const allLocaleCodes = computed<string[]>(() => {
      return Object.keys(localesMap)
    })

    const translatedValues = computed(() => {
      const values: Record<string, string> = {}
      for (const localeCode of allLocaleCodes.value) {
        Object.defineProperty(values, localeCode, {
          get (): string {
            const message =
              localesMap[localeCode]?.messages[props.translationKey]
            return (message as string) || ''
          },
          set (value: string) {
            store.commit('campaigns/UPDATE_TRANSLATION_MESSAGE', {
              locale: localeCode,
              messageId: props.translationKey,
              value: value
            })
          },
          enumerable: true
        })
      }
      return values
    })

    return {
      translatedValues,
      allLocaleCodes,
      localesMap
    }
  }
})
